import type {UserApiModel} from '../../../api/user';
import type {Nullable} from '../../utility-types';

import {currentUserStore} from '../../../api/user';

export const isUserEmployee = (
  user:
    | Nullable<{
        metadata?: Nullable<UserApiModel['metadata']>;
      }>
    | undefined = currentUserStore.user,
) => Boolean(user?.metadata?.onboarding?.account_type === 'employee');
